import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LogoTitle from "../../assets/images/Logo2024.png";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import Loader from "react-loaders";

import Logo from "./Logo";
const Home = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const [isMobile, setIsMobile] = useState(false);
  const nameArray = [
    // 'O',
    "s",
    "h",
    "r",
    "i",
    "e",
    "l",
    " ",
    "T",
    "z",
    "a",
    "g",
    "a",
    "y",
  ];

  const jobArray = [
    "f",
    "u",
    "l",
    "l",
    "-",
    "s",
    "t",
    "a",
    "c",
    "k",
    " ",
    "D",
    "e",
    "v",
    "e",
    "l",
    "o",
    "p",
    "e",
    "r",
  ];

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 5000);
  }, []);

  useEffect(() => {
    const checkScreenWidth = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenWidth();

    window.addEventListener("resize", checkScreenWidth);

    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", checkScreenWidth);
  }, []);
  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>m</span>
            <img src={LogoTitle} alt="developer" className="logo-title" />
            <AnimatedLetters
              strArray={nameArray}
              idx={15}
              letterClass={letterClass}
            />
            <br />
            <AnimatedLetters
              strArray={jobArray}
              idx={21}
              letterClass={letterClass}
            />
          </h1>
          <h2> / Full-Stack Developer / </h2>

          <section style={isMobile ? { display: "flex", gap: "5px" } : {}}>
            <Link to="/contact" className="flat-button">
              CONTACT ME
            </Link>{" "}
            {isMobile && (
              <Link to="/about" className="flat-button">
                ABOUT ME
              </Link>
            )}
          </section>
        </div>
        <Logo />
      </div>
      <Loader type="pacman" />
    </>
  );
};

export default Home;
